import type { AlertErrorHandlerFactory, AlertFactory } from '@/features/shell'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { type Job } from '@/features/jobs/Job'
import { type JobStore } from '@/features/jobs/JobStore'
import { task } from 'mobx-task'

/**
 * View Model for Notify Pros of Open Job Dialog.
 */
export class NotifyProsOfOpenJobDialogViewModel {
  readonly modal = new ModalViewModel()

  constructor(
    private readonly _job: Job,
    private readonly _canNotifyPros: () => boolean,
    private readonly _jobStore: JobStore,
    private readonly _newAlert: AlertFactory,
    private readonly _createAlertErrorHandler: AlertErrorHandlerFactory,
  ) {}

  /**
   * Notifies all pros that the job is available for pickup.
   */
  notifyProsOfOpenJob = task.resolved(async () => {
    if (!this._canNotifyPros()) {
      return
    }

    await this._jobStore
      .notifyProsOfOpenJob(this._job)
      .catch(this._createAlertErrorHandler('Notifying the pros failed'))

    this.modal.close()
    this._newAlert()
      .withState('success')
      .saying('All available pros were successfully notified.')
      .autoDismiss()
      .show()
  })
}
